export const SPACE_TYPES = [
  { name: "Dock or Mooring", value: "dock_or_mooring" },
  { name: "Dock", value: "dock" },
  { name: "Mooring", value: "mooring" },
]
